export const CONTAINER_DEFAULT_SORT_BY = 'addedAt';
export const BL_DEFAULT_SORT_BY = 'updatedAt';
export const SHIPMENT_DEFAULT_SORT_BY = 'updatedAt';
